import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EyeIcon from './../../../assets/svg_main/eye-outline.svg';
import EditIcon from './../../../assets/svg_main/edit_outline.svg';
import {  OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PagePermission } from '../../../services/usePermission';
import './index.css'
import endpoints from '@config/endpoints';
import axios from '@utils/axiosExt';
import { errorLogger } from '@utils/applicationLogUtils';
import Auth from '@utils/auth';
import dayjs from 'dayjs';
import { dateFormate } from '@constants/index';
import { setStatusMessage } from '@constants/approvalConstants';

interface PropsType {
  user: any
};

const ActionComponent = (props: PropsType) => {
  const { user } = props;
 const canEditUser = PagePermission("FcltyMgmt", "FcltyMgmt_EdPg");
 const canViewUser = PagePermission("FcltyMgmt", "FcltyMgmt_OVPg");
 const [disableEditBtn, setDisableEditBtn] = useState(false);
 const [approvalReqId, setApprovalReqId] = useState('');
 const [approvalReqStatus, setApprovalReqStatus] = useState('');
 const [reqefectiveData, setReqefectiveData] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    workflowExistsForApproval()
  }, [user.facilit_id])
  
  const goToEditPage = () => {
    navigate(`/health-facility/update/${user.facilit_id}`, {
      state: JSON.stringify(user),
    });
  };

  const workflowExistsForApproval = async () => {
    let pendingWorkflow = false
    let approvalReqId = '';
    let approvalReqStatus = '';
    let reqefectiveData = '';
    try {
      const reqBody = {
        requestForType: 'Facility',
        requestForId: user.facilit_id
      }
      const facility_details_response = await axios.post(endpoints.workflowExistsForApproval, reqBody, Auth.loggedInWithJSON())
      pendingWorkflow = facility_details_response?.data?.data?.check_workflow_exists_for_approval;
      approvalReqId = facility_details_response?.data?.data?.request_serial_id || '';
      approvalReqStatus = facility_details_response?.data?.data?.v_status_name || '';
      reqefectiveData = facility_details_response?.data?.data?.effective_from_date ? dayjs(facility_details_response?.data?.data?.effective_from_date).format(dateFormate.dd_mm_yyyy) : '';
    } catch(error:any) {
      errorLogger(error?.response?.data||error?.response||error)
    }
    setDisableEditBtn(pendingWorkflow);
    setApprovalReqId(approvalReqId);
    setApprovalReqStatus(approvalReqStatus);
    setReqefectiveData(reqefectiveData);
  }

  const renderTooltip = (text:any) => (
    <Tooltip className="action-tooltip">{text}</Tooltip>
  );


  const goToViewPage = () => {
    navigate(`/health-facility/view/${user.facilit_id}`, {
      state: JSON.stringify(user),
    });
  };

  return (
    <div className="actionWrapper">

{canEditUser && (
        <OverlayTrigger
          placement='bottom'
          overlay={renderTooltip(disableEditBtn ? setStatusMessage(approvalReqStatus, reqefectiveData, approvalReqId, 'facility') : "Edit")}
        >
          <span
            className={disableEditBtn ? 'icon-disabled' : 'icon-active'}
            style={{ pointerEvents: disableEditBtn ? 'visible' : 'auto' }}
            role="button"
            aria-disabled={disableEditBtn}
            onClick={!disableEditBtn ? goToEditPage : undefined}
          >
            <EditIcon />
          </span>
        </OverlayTrigger>
      )}
      {canViewUser && (
        <OverlayTrigger placement='bottom' overlay={renderTooltip("View")}>
          <span className="icon-active">
            <EyeIcon onClick={goToViewPage} />
          </span>
        </OverlayTrigger>
      )}
      
    </div>
  );
};

export default ActionComponent;